<template>
  <div class="app-container">
    <div class="filter-container">
      <el-date-picker
        v-model="queryDate"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="filter-item"
        style="margin-right: 10px"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">新增</el-button>
      <el-button class="filter-item" type="success" icon="el-icon-right"  @click="importBook">导入Excel</el-button>
      <a href="./flowimport.xlsx" download="流向导入模板.xlsx" target="_blank" style="margin:10px;text-decoration:none;border-bottom:1px solid blue">模板下载</a>
      
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
       :max-height="clientHeight" 
      size="mini"
    >
      <el-table-column align="center" label="ID" width="100">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column align="center" label="客户代号" width="80">
        <template slot-scope="scope">{{ scope.row.custid }}</template>
      </el-table-column>
      <el-table-column align="center" label="客户名称" width="140">
        <template slot-scope="scope">{{ scope.row.custname }}</template>
      </el-table-column>
      <el-table-column align="center" label="单据类型" width="80">
        <template slot-scope="scope">{{ scope.row.billtypename }}</template>
      </el-table-column>
      <el-table-column label="单据日期" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.billdate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="品种代号" align="center" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.artid }}</template>
      </el-table-column>
      <el-table-column label="品种名称" align="center" width="120" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="厂家" align="center" width="120" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="70" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column label="批号" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.serial }}</template>
      </el-table-column>
      <el-table-column label="数量" align="center" width="90" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.total }}</template>
      </el-table-column>
      <el-table-column label="价格" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.price }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150px">
        <template slot-scope="scope">
          
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">
            <i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog customClass="customWidth"

        :modal="true" 

        :visible.sync="ImportdialogVisible"

         width="29%"

        :title="ImportTitle"    

     >

     

      <el-form :model="form">

        <el-form-item>

          <el-upload class="upload-file"

            drag

            ref="uploadExcel"

            action="http://222.240.174.182:9099/api/productinfo/flowimport"

            :limit=limitNum

            :auto-upload="false"

            accept=".xlsx"

            :before-upload="beforeUploadFile"

            :on-change="fileChange"

            :on-exceed="exceedFile"

            :on-success="handleSuccess"

            :on-error="handleError"

            :file-list="fileList"

          >

          <i class="el-icon-upload"></i>

          <div class="el-upload__text">将文件拖到此处，或<em>点击选择Excel文件</em></div>

          <!-- <div slot="tip" class="el-upload-list__item-name">{{fileName}}</div> -->

          </el-upload>

      </el-form-item>

      <el-form-item>

          <div style="margin-left: 120px;">

            <el-button @click="ImportdialogVisible = false" size="small">取 消</el-button>

            <el-button size="small" type="primary" @click="submitUpload()">立即导入</el-button>

          </div>

      </el-form-item>

    </el-form> 

  </el-dialog>

  <el-dialog customClass="customWidth"

        :modal="true" 

        :visible.sync="AdddialogVisible"

         width="29%"

        title="新增明细"    

     >
     <el-form :model="form" label-width="80px">

      <el-form-item label="客户">
          <el-autocomplete
            class="inline-input"
            v-model="addform.custstr"
            :fetch-suggestions="querySearch"
            placeholder="请输入客户ID或者客户名称"
            @select="handleSelect"
          ></el-autocomplete>
      </el-form-item>

      <el-form-item label="单据类型">
          <el-select v-model="addform.billtypeid" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="单据时间">
          <el-date-picker
            v-model="addform.billdatestr"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
      </el-form-item>

      <el-form-item label="商品">
          <el-select v-model="addform.artid" placeholder="请选择">
            <el-option
              v-for="item in arts"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="批号">
          <el-input v-model="addform.serial" placeholder="请输入批号" style="width: 68%;"></el-input>
      </el-form-item>

      <el-form-item label="数量">
          <el-input v-model="addform.total" type="number" placeholder="请输入数量" style="width: 68%;"></el-input>
      </el-form-item>

      <el-form-item label="价格">
          <el-input v-model="addform.price" type="number" placeholder="请输入价格" style="width: 68%;"></el-input>
      </el-form-item>

      <el-form-item>

          <div style="margin-left: 120px;">

            <el-button @click="AdddialogVisible = false" size="small">取 消</el-button>

            <el-button size="small" type="primary" @click="submitAdd()">保存</el-button>

          </div>

      </el-form-item>

    </el-form> 
  </el-dialog>

     <!--分页-->
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    >
    </pagination>
  </div>
</template>

<script>
import { getFlowImport,selectCustList,saveFlow,deleteFlow } from '@/api/flow'
import Pagination from '@/components/Pagination'

export default {
  name: 'ProductInfo',

   components: {
     Pagination
   },

  data() {
    return {
      clientHeight: '800',
      queryDate: [],
      list: null,
       total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        asc: false,
        startDate:'',
        endDate:''
      },
      code: '',
      artid: '',
      listLoading: false,
      downloadLoading: false,
      ImportdialogVisible:false, //"导入"对话框是否可见
      AdddialogVisible:false,
      ImportTitle:'导入Excel', //"导入"对话框的标题
      limitNum: 1,//导入文件的个数
      form: {    //"导入"表单绑定file，并初始化
          file: ''
        },
      addform:{
        custid:'',
        custstr:'',
        billtypeid:'',
        billdatestr:'',
        artid:'',
        serial:'',
        total:'',
        price:''
      },
       options: [{
          value: '2101',
          label: '销售出库单'
        }, {
          value: '2201',
          label: '销售退货单'
        }],
         arts: [{
          value: '46196',
          label: '速效救心丸'
        }, {
          value: '116827',
          label: '#京万红软膏'
        }],
      fileList: [],//"导入"文件列表
    }
  },

  created() {
    this.getList();
    this.initHeight()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },
    querySearch(queryString, cb){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if(!queryString){
            return;
          }
          selectCustList(queryString)
            .then(response => {
              cb(response.data);
            })
            .catch(() => {
            
            })
        }, 1000 * Math.random());

    },
    handleSelect(item) {
        this.addform.custid=item.id;
    },
    submitAdd(){
      if(this.addform.artid==''){
          this.$notify.warning({

            title: '提示',

            message: `请选择商品`

          });
          return;
      }
      
       let self = this;
        saveFlow(this.addform)
          .then(response => {
              this.$notify.success({

              title: '成功',

              message: `保存成功`

              });

              this.getList();

              self.AdddialogVisible = false; 
               this.addform={
                  custid:'',
                  billtypeid:'',
                  billdatestr:'',
                  artid:'',
                  serial:'',
                  total:'',
                  price:'',
                  custstr:''
                };
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
    },
    handleDelete(id) {
      this.$confirm('是否确认删除该条记录?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteFlow(id).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        })
        .catch(() => {})
    },
    getList() {
      this.list = []
      let [start, end] = this.queryDate || []
      this.listQuery.startDate = start
      this.listQuery.endDate = end
        this.listLoading = true
        getFlowImport(this.listQuery)
          .then(response => {
            this.list = response.data.items
            this.total = response.data.total
            this.listLoading = false
            this.listLoading = false
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
      
    },
    // 新增按钮跳转到新增采购单
    handleCreate() {
      this.AdddialogVisible = true;
    },
    importBook(){ //弹出导入对话框

      let self = this;

      self.ImportdialogVisible = true;

    },

    // 文件超出个数限制时的钩子

    exceedFile(files, fileList) {

          this.$notify.warning({

          title: '警告',

          message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`

      });

    },

    // 文件状态改变时的钩子

    fileChange(file, fileList) {

        console.log('change')

        console.log(file)

        this.form.file = file.raw

        console.log(this.form.file)

        console.log(fileList)

      },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传

    beforeUploadFile(file) {

        console.log('before upload')

        console.log(file)

      // let extension = file.name.substring(file.name.lastIndexOf('.')+1); //获取上传文件的扩展名

        //console.log("文件扩展名为:"+extension);

        let size = file.size / 1024 / 1024; //设置上传文件的大小

        const isXLSX = file.name.split(".")[1] === 'xlsx'; //获取上传文件的扩展名

        if(!isXLSX){

            this.$notify.warning({

            title: '警告',

            message: `只能上传Excel2017（即后缀是.xlsx）的文件`

          });

          

        }

        if(size > 10) {

            this.$notify.warning({

            title: '警告',

            message: `文件大小不得超过10M`

          });

          

        }

        

      },

      // 文件上传成功时的钩子

      handleSuccess(res, file, fileList) {

          let self = this;

          this.$notify.success({

          title: '成功',

          message: `文件导入成功`

          });

          this.getList();

          self.ImportdialogVisible = false;  

      },

      // 文件上传失败时的钩子

      handleError(err, file, fileList) {

          this.$notify.error({

          title: '错误',

          message: `文件导入失败`

          });

      },

      submitUpload(){

          let self = this;

          if(self.form.file == ''){

            this.$notify.error({

              title: '错误',

              message: `请选择要导入的文件`

            });

            return;

          }

          self.$refs.uploadExcel.submit();

      },
    // 格式化数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    }
   }
}
</script>
